import React from "react";
import { TabContent, TabPane } from "reactstrap";

// hooks
import { useRedux } from "../../hooks/index";
import { createSelector } from "reselect";
// constants
import { TABS } from "../../constants/index";

// component
import Profile from "./Profile/index";
import Customers from "./Customers/index";
import Services from "./Services/index";
import Templates from "./Templates/index";
import Invoice from "./Invoice/index";
import Settings from "./Settings/index";

interface LeftbarProps {}
const Leftbar = (props: LeftbarProps) => {
  // global store
  const { useAppSelector } = useRedux();

  const { activeTab } = useAppSelector(state => ({
    activeTab: state.Layout.activeTab,
  }));
  const errorData = createSelector(
    (state: any) => state.Layout,
    state => ({
      activeTab: state.activeTab,
    }),
  );
  // Inside your component
  // const { activeTab} = useAppSelector(errorData);

  return (
    <>
      {/* start chat-leftsidebar */}
      <div className="chat-leftsidebar">
        <TabContent activeTab={activeTab}>
          {/* Start Profile tab-pane */}
          <TabPane tabId={TABS.USERS} role="tabpanel">
            <Profile />
          </TabPane>

          <TabPane tabId={TABS.CUSTOMERS} role="tabpanel">
            <Customers />
          </TabPane>

          <TabPane tabId={TABS.CONTACTS} role="tabpanel">
            <Services />
          </TabPane>

          <TabPane tabId={TABS.CALLS} role="tabpanel">
            <Templates />
          </TabPane>

          <TabPane tabId={TABS.BOOKMARK} role="tabpanel">
            <Invoice />
          </TabPane>

          <TabPane tabId={TABS.SETTINGS} role="tabpanel">
            <Settings />
          </TabPane>
        </TabContent>
      </div>
    </>
  );
};

export default Leftbar;
